import React from 'react';
import {Button} from 'antd';
import AuthStorage from 'src/utils/AuthStorage';
import FileSaver from 'file-saver';
import API from 'src/constants/url';
const { API_URL } = API;

// eslint-disable-next-line func-names
const serialize = function(obj, prefix) {
  var str = [], p;
  for (p in obj) {
    if(!obj[p]) continue;
    if (obj.hasOwnProperty(p)) {
      var k = prefix ? prefix + "[]" : p,
        v = obj[p];
      str.push((v !== null && typeof v === "object") ?
        serialize(v, k) :
        encodeURIComponent(k) + "=" + encodeURIComponent(v));
    }
  }
  return str.join("&");
};

const api = async (url, filename) => {
   fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'text/csv',
        'Content-Type': 'text/csv',
        'Authorization': `Bearer ${AuthStorage.token}`,
      }
    }) 
    .then(response => response.blob())
    .then(blob => {
      FileSaver.saveAs(blob, filename || 'export.csv');
    });
};

function ButtonExportCsvByUrl(props) {
  const onExport = async () => {
    let url;
    const params = serialize(props.payload);
    if(props.url) {
      url = `${API_URL}${props.url}?${params}`;
    }
    else {
      url = [];
    }
    await api(url, props.filename);
  };

  return (
    <Button onClick={onExport} type="link" icon="export">
      Format CSV
    </Button>
  );
}

export default ButtonExportCsvByUrl;